<script>
  import Temp from './Temp.svelte';

  export let locations = [
    {
      name: 'name',
      src: '/svg/snowflake.svg',
      devices: [{ name: 'device', temperatureRefrigerator: 'refrigerator', temperatureFreezer: 'freezer' }],
    },
  ];

  let URL_BASE = 'https://api.ubibot.com/';

  let selectedLocation = null;
  let selectedDevice = null;

  const formatTime = (data) => {
    let time = new Date(data).toLocaleTimeString();

    return time.substring(0, time.length - 3);
  };

  async function loadDeviceHistory(location, device, index) {
    selectedLocation = location;
    selectedDevice = device;

    if (device.feeds) {
      return;
    }

    const res = await fetch(
      `${URL_BASE}channels/${device.channel}/summary.json?api_key=${device.api_key}&results=${location.results}`
    );

    const data = await res.json();

    let feeds = data.feeds.map((feed) => {
      let mfeed = { created_at: formatTime(feed.created_at) };

      if (!feed.field7) {
        mfeed = { ...mfeed, f7avg: 'N/A', f7min: 'N/A', f7max: 'N/A' };
      } else {
        mfeed = {
          ...mfeed,
          f7avg: feed.field7.avg.toFixed(2),
          f7min: feed.field7.min.toFixed(2),
          f7max: feed.field7.max.toFixed(2),
        };
      }

      if (!feed.field10) {
        mfeed = { ...mfeed, f10avg: 'N/A', f10min: 'N/A', f10max: 'N/A' };
      } else {
        mfeed = {
          ...mfeed,
          f10avg: feed.field10.avg.toFixed(2),
          f10min: feed.field10.min.toFixed(2),
          f10max: feed.field10.max.toFixed(2),
        };
      }

      return mfeed;
    });

    if (data.result == 'success') {
      location.devices[index].feeds = feeds;

      selectedLocation = location;
      selectedDevice = device;
    } else {
      throw new Error(data.result);
    }
  }

  function init(element) {
    element.scrollIntoView({ block: 'end', behavior: 'smooth' });
  }

  function clearLoaded() {
    selectedLocation = null;
    selectedDevice = null;
  }

  function getColor(temperature, freezer = false) {
    let normalMin = 0;
    let normalMax = 4;
    let badMin = -3;
    let badMax = 8;

    if (freezer) {
      normalMin = -10;
      normalMax = -8;
      badMin = -14;
      badMax = -4;
    }

    if (temperature >= normalMin && temperature <= normalMax) return 'green';
    else if (temperature <= badMin || temperature >= badMax) return 'red';
    else return 'yellow';
  }
</script>

<div class="flex flex-col w-full">
  {#if selectedDevice != null}
    <button on:click={clearLoaded}> Atras </button>

    <br />
    <br />

    <h1 class="text-center font-bold text-xl">
      {selectedLocation.name} - {selectedDevice.name}
    </h1>

    <div class="flex flex-col md:flex-row">
      <div class="flex flex-col w-1/2 m-auto">
        <h2 class="text-center font-bold text-lg">Refrigerador</h2>
        <Temp temperature={selectedDevice.temperatureRefrigerator.value} />
      </div>

      {#if selectedDevice.temperatureFreezer.value}
        <div class="flex flex-col w-1/2 m-auto">
          <h2 class="text-center font-bold text-lg">Congelador</h2>
          <Temp temperature={selectedDevice.temperatureFreezer.value} freezer={true} />
        </div>
      {/if}
    </div>
    {#if selectedDevice.feeds}
      <small>
        {selectedDevice.last_entry_date}
      </small>

      <table>
        <thead>
          <tr>
            <th>Hora</th>
            <th class="border-l-2 border-solid border-black">Prom</th>
            <th>Min</th>
            <th>Max</th>
            {#if selectedDevice.temperatureFreezer.value}
              <th class="border-l-2 border-solid border-black">Prom</th>
              <th>Min</th>
              <th>Max</th>
            {/if}
          </tr>
        </thead>
        <tbody use:init>
          {#each selectedDevice.feeds as feed}
            <tr>
              <td>
                {feed.created_at}
              </td>
              <td class="border-l-2 border-solid border-black">
                <b>{feed.f7avg}</b>
              </td>
              <td>
                {feed.f7min}
              </td>
              <td>
                {feed.f7max}
              </td>

              {#if selectedDevice.temperatureFreezer.value}
                <td class="border-l-2 border-solid border-black">
                  <b>{feed.f10avg}</b>
                </td>
                <td>
                  {feed.f10min}
                </td>
                <td>
                  {feed.f10max}
                </td>
              {/if}
            </tr>
          {/each}
        </tbody>
      </table>
    {/if}
  {:else}
    {#each locations as location}
      <article class="flex flex-row p-2 md:p-4">
        <div class="flex flex-col p-2 md:p-4">
          <h1>{location.name}</h1>
          <img src={location.src ? location.src : '/svg/snowflake.svg'} alt="logo" />
        </div>
        <div class="w-full grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-2 md:gap-4">
          {#each location.devices as device, i}
            <div
              class="flex flex-col cursor-pointer border-2 border-black border-dashed p-2 md:p-4 shadow-2xl hover:shadow-hover"
              on:click={loadDeviceHistory(location, device, i)}
            >
              <h1>{device.name}</h1>
              <div class="flex flex-row justify-between {getColor(device.temperatureRefrigerator.value)}">
                <span>Refrigerador</span>
                <b>{device.temperatureRefrigerator.value}°C</b>
              </div>

              {#if device.temperatureFreezer.value}
                <div class="flex flex-row justify-between {getColor(device.temperatureFreezer.value, true)}">
                  <span>Congelador</span>
                  <b>{device.temperatureFreezer.value}°C</b>
                </div>
              {/if}
            </div>
          {/each}
        </div>
      </article>
    {/each}
  {/if}
</div>

<style>
  .green {
    background-color: #a9ffa3;
  }

  .red {
    background-color: #ffa3a3;
  }

  .yellow {
    background-color: #fffca3;
  }

  thead {
    @apply text-left;
  }

  .shadow-hover {
    box-shadow: -4px 4px black;
  }

  /* h1 {
    margin: 0;
  }

  button {
    background-color: white;
    font-weight: bold;
    font-size: larger;
    border: 1px solid black;
    margin: 0;
  }

  .pointer {
    cursor: pointer;
  }

  article {
    overflow: auto;
  }

  .j-between {
    justify-content: space-between;
  }

  .flex {
    display: flex;
  }

  .row {
    flex-direction: row;
  }

  .m-auto {
    margin: auto;
  }

  .col {
    flex-direction: column;
  }

  .content {
    margin: 0 auto;
    text-align: left;
    gap: 16px;
    padding: 16px 0;
  }

  .dashed {
    border: 2px dashed black;
  }

  .green {
    background-color: #a9ffa3;
  }

  .red {
    background-color: #ffa3a3;
  }

  .yellow {
    background-color: #fffca3;
  }

  .grid {
    display: grid;
    width: 100%;
    grid-template-columns: repeat(2, 1fr);
    margin-left: 8px;
    gap: 8px;
  }

  .p-8 {
    padding: 8px;
  }

  .shadow {
    box-shadow: 0 24px 38px 3px rgb(0 0 0 / 14%), 0 9px 46px 8px rgb(0 0 0 / 12%), 0 11px 15px -7px rgb(0 0 0 / 20%);
  }

  .shadow:hover {
    box-shadow: -4px 4px black;
  }

  @media (min-width: 768px) {
    .content {
      width: 60%;
    }
  }

  @media (max-width: 768px) {
    .respo {
      flex-direction: column;
    }
  }

  small {
    text-align: center;
    font-weight: bold;
  }

  table {
    margin: auto;
  }

  thead {
    text-align: left;
  }

  th {
    padding-right: 30px;
  } */

  /* th {
    @apply text-right;
  } */
</style>
